import '@microsoft/applicationinsights-shims';
import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { history } from "./_helpers";

import { alertActions, registrationActions, userActions } from "./_actions";
import { PrivateRoute } from "./components/PrivateRoute";
import { GuestRoute } from "./components/GuestRoute";

import { Layout } from "./components/Layout";
import MyProfile from "./components/MyProfile";
import { NewLoan } from "./components/NewLoan";
import { IncreaseRefinance } from "./components/IncreaseRefinance";
import AccountHistory from "./components/AccountHistory";
import { LogOut } from "./components/LogOut";
import { LogInMain } from "./components/LogInMain";

import { FindOffice } from "./components/subcomponents/FindOffice";
import { NewLoanApp } from "./components/subcomponents/NewLoanApp";
import { GetStarted } from "./components/subcomponents/GetStarted";
import { PreApproval } from "./components/subcomponents/PreApproval";
import { PersonalInfo } from "./components/subcomponents/PersonalInfo";
import { FinancialInfo } from "./components/subcomponents/FinancialInfo";
import { Confirmation } from "./components/subcomponents/Confirmation";
import { LoanSubmittedConfirmation } from "./components/subcomponents/LoanSubmittedConfirmation";
import { Welcome } from "./components/subcomponents/Welcome";
import ConfirmationSummary from "./components/subcomponents/ConfirmationSummary";
import { ChangePasswordPage } from "./components/ChangePassword";
import { AccountSuspended } from "./components/AccountSuspended";
import { SuspendedFlag } from "./components/SuspendedFlag";
import { ProfileInfo } from "./components/subcomponents/ProfileInfo";
import { SignUpCustomerStatus } from "./components/subcomponents/SignUpCustomerStatus";
import { SignUpVerifyIdentity } from "./components/subcomponents/SignUpVerifyIdentity";
import { SignUpCreatePassword } from "./components/subcomponents/SignUpCreatePassword";
import { SignUpEmailValidation } from "./components/subcomponents/SignUpEmailValidation";
import { SignUpOptInValidation } from "./components/subcomponents/SignUpOptInValidation";
import { BiometricOption } from "./components/subcomponents/BiometricOption";
import { ServiceUtil } from "./_services/services.util";
import { MakePayment } from "./components/MakePayment";
import { ForgotPassword } from "./components/ForgotPassword";
import { Error } from "./components/Error";
import NewLoanAppLanding from "./components/NewLoanAppLanding";
import { FundingSelection } from "./components/FundingSelection";
import { BankingInfo } from "./components/subcomponents/BankingInfo";
import { NoBusinessInState } from "./components/NoBusinessInState";
import MyDocuments from "./components/MyDocuments";
import ViewDocument_NewTab from "./components/ViewDocument_NewTab";
import { FundingAmount } from "./components/FundingAmount";
import DocumentPage from "./components/DocumentPage";
import { userService } from "./_services";
import { Maintenance } from "./components/Maintenance";
import SecureUpload from "./components/SecureUpload";

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

class App extends Component {
    constructor(props) {
        super(props);

        history.listen((location, action) => {
            // clear alert on location change
            this.props.actions.clearAlerts();
        });
        ServiceUtil.getSharedConfiguration();
    }
    static displayName = App.name;
    async UNSAFE_componentWillMount() {
        //await ServiceUtil.loadServiceUrls();
    }

    componentDidMount() {
        ServiceUtil.getServiceUrl("AppInsights").then(connectionString => {
            if (connectionString !== "") {
                const reactPlugin = new ReactPlugin();
                const appInsights = new ApplicationInsights({
                    config: {
                        connectionString
                        /* ...Other Configuration Options... */
                        // if local => disableTelemetry: true
                    },
                    extentions: [reactPlugin],
                    extentionConfig: {
                        [reactPlugin.identifier]: { history: history }
                    }
                });
                appInsights.loadAppInsights();
                appInsights.trackPageView();
            } else {
                console.log("App insights disabled");
            }
        });

        ServiceUtil.getReCaptchaSiteKey().then(siteKey => {
            this.loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${siteKey}`);
        });

        this.props.actions.updateAppOnlineDisclosure();
        this.consumeSunLoanCookies();
    }

    componentDidUpdate() {
        if (!this.props.disclosure || (this.props.disclosure.isDefault && !this.props.disclosure.isLoading)) {
            // No matter where we are, we should keep trying to load the disclosure if it's not set or is using the fallback.
            this.props.actions.updateAppOnlineDisclosure();
        }

        if (!window.TrustevV2) { //ad blockers can cause this
            return;
        }

        var trustevKey = JSON.parse(sessionStorage.getItem("trustev"));

        if (trustevKey === null) {
            ServiceUtil.getTrustevKey().then(key => {
                sessionStorage.setItem("trustev", JSON.stringify(key));
                trustevKey = key;
                window.TrustevV2.Init(trustevKey, function (sessionId) {
                    sessionStorage.setItem("trustevId", JSON.stringify(sessionId));
                });

            });
        } else {
            window.TrustevV2.Init(trustevKey, function (sessionId) {
                sessionStorage.setItem("trustevId", JSON.stringify(sessionId));
            });
        }
    }


    loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
    }

    consumeSunLoanCookies = () => {
        let langCookie = Cookies.get("wp-wpml_current_language_sitewide");
        let marketingCookies = {
            campaign: Cookies.get("utm_campaign"),
            sourceCookie: Cookies.get("utm_source"),
            mediumCookie: Cookies.get("utm_medium"),
            contentCookie: Cookies.get("utm_content"),
            termCookie: Cookies.get("utm_term"),
            gclidCookie: Cookies.get("gclid"),
            fbclidCookie: Cookies.get("fbclid"),
            msclkidCookie: Cookies.get("MSCLKID")
        }

        if (langCookie !== undefined) {
            let newLanguage = langCookie.toUpperCase();
            if (newLanguage == userService.LANGUAGES.EN || newLanguage == userService.LANGUAGES.ES) {
                this.props.actions.setAppLanguage(newLanguage);
            }
        }

        this.props.actions.handleSetMarketing(marketingCookies);

    }

    render() {
        const { isLPXInMaintenance } = this.props;
        return (
            <Layout>
                {isLPXInMaintenance === true ? <Switch>
                    <Route
                        path="*"
                        component={Maintenance} />
                </Switch>
                    : <Switch>
                        <PrivateRoute exact path="/my-account" component={AccountHistory} />
                        <PrivateRoute exact path="/" component={AccountHistory} />
                        <PrivateRoute path="/my-profile" component={MyProfile} />
                        <PrivateRoute path="/my-documents" component={MyDocuments} />
                        <PrivateRoute path="/account-history" component={AccountHistory} />
                        <PrivateRoute
                            path="/change-password"
                            component={ChangePasswordPage}
                        />
                        <PrivateRoute
                            path="/log-out"
                            component={LogOut}
                            shouldRenew={false}
                        />
                        <PrivateRoute path="/make-payment/:id" component={MakePayment} />
                        <PrivateRoute path="/view-document" component={ViewDocument_NewTab} />
                        <GuestRoute path="/secure-upload" component={SecureUpload} pageName="DocumentSecureUpload" />
                        <GuestRoute path="/make-payment" component={MakePayment} pageName="MakePayment" sectionName="ToMakeAPayment" />

                        <Route path="/new-loan" component={NewLoan} />
                        <Route path="/account-suspended" component={AccountSuspended} />
                        <Route path="/SuspendedFlag" component={SuspendedFlag} />
                        <Route path="/LogInMain" component={LogInMain} exact />
                        <Route path="/LogInMain/:hash" component={LogInMain} />
                        <Route path="/FindOffice" component={FindOffice} />
                        <Route path="/NewLoanApp" component={NewLoanApp} />
                        <Route path="/Welcome" component={Welcome} />
                        <Route path="/ConfirmationSummary" component={ConfirmationSummary} />
                        <Route path="/GetStarted" component={GetStarted} />
                        <Route path="/PreApproval" component={PreApproval} />
                        <Route path="/FinancialInfo" component={FinancialInfo} />
                        <Route path="/PersonalInfo" component={PersonalInfo} />
                        <Route path="/Confirmation" component={Confirmation} />
                        <Route path="/LoanSubmittedConfirmation" component={LoanSubmittedConfirmation} />
                        <Route path="/ForgotPassword" component={ForgotPassword} />
                        <Route
                            path="/SignUpCustomerStatus"
                            component={SignUpCustomerStatus}
                        />
                        <Route path="/ProfileInfo" component={ProfileInfo} />
                        <Route
                            path="/SignUpVerifyIdentity"
                            component={SignUpVerifyIdentity}
                        />
                        <Route
                            path="/SignUpCreatePassword"
                            component={SignUpCreatePassword}
                        />
                        <Route
                            path="/SignUpEmailValidation"
                            component={SignUpEmailValidation}
                        />
                        <Route
                            path="/SignUpOptInValidation"
                            component={SignUpOptInValidation}
                        />
                        <Route path="/SignUpLogIn" component={LogInMain} />
                        <Route path="/BiometricOption" component={BiometricOption} />
                        <Route path="/NewLoanAppLanding/:hash" component={NewLoanAppLanding} />
                        <Route path="/NewLoanAppLanding" component={NewLoanAppLanding} />
                        <Route exact path="/Refinance/SelectLoan" component={IncreaseRefinance} />
                        <Route exact path="/Refinance/PersonalInfo" component={PersonalInfo} />
                        <Route exact path="/Refinance/FinancialInfo" component={FinancialInfo} />
                        <Route exact path="/Refinance/FundingSelection" component={FundingSelection} />
                        <Route exact path="/Refinance/Summary" component={ConfirmationSummary} />
                        <Route path="/FundingSelection" component={FundingSelection} />
                        <Route path="/BankingInfo" component={BankingInfo} />
                        <Route path="/Error" component={Error} />
                        <Route path="/NoBusinessInState" component={NoBusinessInState} />
                        <Route path="/FundingAmount" component={FundingAmount} />
                        
                        <Route exact path="/Document/:hash" component={DocumentPage} />
                    </Switch>}
            </Layout>
        );
    }
}
function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert,
        language: state.users.language,
        disclosure: state.users.disclosure,
        isLPXInMaintenance: state.configuration.isLPXInMaintenance,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            updateAppOnlineDisclosure: (data) => {
                dispatch(userActions.updateAppOnlineDisclosure(data));
            },
            handleSetMarketing: (data) => {
                dispatch(registrationActions.handleSetMarketing(data));
            },
            clearAlerts: (data) => {
                dispatch(alertActions.clear());
            },
            setAppLanguage: (data) => {
                dispatch(userActions.setAppLanguage(data))
            }
        },

    }
}

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(App);
export { connectedApp as App };
